export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_TEMPLATE_BY_ID = "GET_TEMPLATE_BY_ID";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const SEND_TEMPLATE_EMAIL = "SEND_TEMPLATE_EMAIL";
